function app(state = {}, action) {
    switch (action.type) {
        case 'SPLASH_SHOW_LOADING': {
            const { title, description } = action;
            return { show: true, title, description };
        }
        case 'SPLASH_SHOW_BALL': {
            const { title, description } = action;
            return { show: false, showBall: true, title, description };
        }
        case 'SPLASH_SHOW_SAVING': {
            const { title, description } = action;
            return { show: true, title, description };
        }
        case 'SPLASH_SHOW_DONE': {
            const { title, description } = action;
            return { show: true, title, description };
        }
        case 'SPLASH_SHOW':
            return { show: true };
        case 'SPLASH_HIDE':
            return { show: false };

        default:
            return state;
    }
}

export default app;
